import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Image,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPhotoUrl } from "utils/common";
import Actions from "./components/Actions";
import CollectionDetailModal from "./components/DetailModal";
import * as collectionActions from "./slice";

function Collection() {
  const dispatch = useDispatch();
  const { collections, pagination, isLoading, isProcessing, isCompleted } =
    useSelector((state) => state.collection);

  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectingCollection, setSelectingCollection] = useState(null);
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    dispatch(collectionActions.fetchCollections(pagination));
  }, []);

  useEffect(() => {
    if (isCompleted) {
      setOpenDetailModal(false);
      setSelectingCollection(null);
    }
  }, [isCompleted]);

  const onOpenDetailModal = (collection = null) => {
    setSelectingCollection(collection);
    setOpenDetailModal(true);
  };

  const onDelete = (collection) => {
    Modal.confirm({
      title: `Xác nhận xoá bộ sưu tập`,
      content: `Bạn có chắc chắn muốn xoá bộ sưu tập này?`,
      onOk: () => dispatch(collectionActions.deleteCollection(collection._id)),
      centered: true,
    });
  };

  const onSubmit = (collection, formData) => {
    if (collection._id) {
      dispatch(collectionActions.updateCollection(collection, formData));
    } else {
      dispatch(collectionActions.createCollection(formData));
    }
  };

  const onCancel = () => {
    setOpenDetailModal(false);
    setSelectingCollection(null);
    dispatch(collectionActions.setIsProcessing(false));
  };

  const onChangeNameSearch = (e) => {
    setSearchName(e.target.value);
  };

  const onSearch = () => {
    dispatch(
      collectionActions.fetchCollections({
        ...pagination,
        name: searchName,
      })
    );
  };

  const onTableChange = async (pagination) => {
    dispatch(
      collectionActions.fetchCollections({
        ...pagination,
        name: searchName,
      })
    );
  };
  const columns = [
    {
      title: "STT",
      align: "center",
      width: "5%",
      render: (text, record, index) => (
        <Typography.Paragraph
          copyable={{
            text: record._id,
            tooltips: ["Sao chép ID", "Đã sao chép!"],
          }}
        >
          {(pagination.current - 1) * pagination.pageSize + index + 1}
        </Typography.Paragraph>
      ),
    },
    {
      title: "Ảnh thumb",
      dataIndex: "thumb",
      width: "10%",
      render: (image) =>
        image ? (
          <Image
            alt="BST"
            src={getPhotoUrl(image?.path || null)}
            width={100}
            height={100}
          />
        ) : null,
    },
    {
      title: "Ảnh cover",
      dataIndex: "cover",
      width: "280px",
      render: (image) =>
        image ? (
          <Image
            alt="BST"
            src={getPhotoUrl(image?.path || null)}
            width={250}
            height={100}
          />
        ) : null,
    },
    {
      title: "Tên bộ sưu tập",
      dataIndex: "name",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "Số nhà hàng",
      dataIndex: "restaurantCount",
      align: "center",
      width: "10%",
    },
    {
      title: "Ưu tiên",
      dataIndex: "priority",
      align: "center",
      width: "10%",
      sorter: (a, b) => a.priority - b.priority,
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      align: "center",
      width: 150,
      render: (active) =>
        active ? (
          <Tag color="#4caf50">Active</Tag>
        ) : (
          <Tag color="#f44336">In-active</Tag>
        ),
    },
    {
      title: "Thao tác",
      align: "center",
      width: "15%",
      render: (record) => (
        <Actions
          record={record}
          onEdit={onOpenDetailModal}
          onDelete={onDelete}
        />
      ),
    },
  ];
  return (
    <>
      <Row justify="space-between" align="middle">
        <Typography.Title level={2}>
          [{pagination?.total || "0"}] Bộ sưu tập
        </Typography.Title>
        <Space size="middle">
          <Input.Search
            placeholder="Tìm theo tên"
            onChange={onChangeNameSearch}
            onSearch={onSearch}
            enterButton
            allowClear
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => onOpenDetailModal()}
          >
            Thêm mới
          </Button>
        </Space>
      </Row>
      <Divider />
      <Table
        bordered
        loading={isLoading}
        columns={columns}
        dataSource={collections}
        rowKey={(record) => record._id}
        pagination={pagination}
        onChange={onTableChange}
      />
      {openDetailModal && (
        <CollectionDetailModal
          open={openDetailModal}
          isProcessing={isProcessing}
          onSubmit={onSubmit}
          onCancel={onCancel}
          collection={selectingCollection}
        />
      )}
    </>
  );
}

export default Collection;
